export default "__VITE_ASSET__DHjy$56V__"